import { getStyles as e } from "./style.js";
import { cn as t } from "../../cn.js";
import { FormErrorText as n, FormHelperText as r, FormLabel as i } from "../shared/form-primitives.js";
import { FilterSearchInput as a } from "./presets.js";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { Field as c, useFieldContext as l } from "@ark-ui/react/field";
// src/design/forms/input-text/index.tsx
var u = ({ label: a, helperText: l, errorText: u, required: d, config: f, className: p, disabled: m, invalid: h, rootClassName: g, ..._ }) => {
	let v = e(f), y = !!u || h;
	return /* @__PURE__ */ s(c.Root, {
		className: t(v.root({ disabled: m }), g),
		invalid: y,
		required: d,
		disabled: m,
		children: [
			a && /* @__PURE__ */ o(i, {
				required: d,
				disabled: m,
				children: a
			}),
			/* @__PURE__ */ o(c.Input, {
				className: t(v.input(y), p),
				..._
			}),
			l && !u && /* @__PURE__ */ o(r, { children: l }),
			u && /* @__PURE__ */ o(n, { children: u })
		]
	});
}, d = Object.assign(u, {
	Default: u,
	Root: ({ children: n, className: r, ...i }) => {
		let a = e();
		return /* @__PURE__ */ o(c.Root, {
			className: t(a.root({ disabled: i.disabled }), r),
			...i,
			children: n
		});
	},
	Label: ({ children: e, className: t, required: n, ...r }) => /* @__PURE__ */ o(i, {
		className: t,
		required: n,
		...r,
		children: e
	}),
	Input: ({ className: n, config: r, invalid: i, ...a }) => {
		let s = e(r), u = l();
		return /* @__PURE__ */ o(c.Input, {
			className: t(s.input(i ?? u?.invalid), n),
			...a
		});
	},
	TextArea: ({ className: n, config: r, invalid: i, ...a }) => {
		let s = e(r), u = l();
		return /* @__PURE__ */ o(c.Textarea, {
			className: t(s.textarea(i ?? u?.invalid), n),
			...a
		});
	},
	HelperText: ({ children: e, className: t, ...n }) => /* @__PURE__ */ o(r, {
		className: t,
		...n,
		children: e
	}),
	ErrorText: ({ children: e, className: t, ...r }) => /* @__PURE__ */ o(n, {
		className: t,
		...r,
		children: e
	}),
	RequiredIndicator: ({ children: n, className: r, ...i }) => {
		let a = e();
		return /* @__PURE__ */ o(c.RequiredIndicator, {
			className: t(a.requiredIndicator(), r),
			...i,
			children: n ?? "*"
		});
	},
	FilterSearch: a,
	getStyles: e
});
export { d as InputText };

//# sourceMappingURL=index.js.map